module.exports = __webpack_public_path__ + "img/zs2.c4537f8b.jpg";